import CertificateWarningViewModel from "@/models/security/zorgID/certificateWarningViewModel";

export default class SecureElementViewModel {
  public IsCancelled?: boolean;

  public CancelledReason?: number;

  public CancelledReasonDisplayValue?: string;

  public Label?: string;

  public HasWarnings?: boolean;

  public Warnings: CertificateWarningViewModel[] = [];

  public IsServerPass?: boolean;

  public PassType?: string;

  public IsValidUserPass?: boolean;

  public AgbCode?: string;

  public UziNumber?: string;

  public UziNumberOid?: string;

  public UziRegisterSubscriberNumber?: string;

  public UziRegisterSubscriberOid?: string;

  public CommonName?: string;

  public SubjectName?: string;

  public OrganizationName?: string;

  public Title?: string;

  public PassholderName?: string;

  public PassholderDescription?: string;

  public Role?: string;

  public RoleCode?: string;

  public SerialNumber?: string;

  public IssuerName?: string;
}
